/**
 * OnThisDayCard - Memories from this day in past years
 *
 * Shows reflections created on this date in previous years,
 * helping users revisit old memories.
 */

import React from 'react';
import { getYearInTimezone } from '../../utils/dateUtils';

function OnThisDayCard({ memories, onViewMemory, timezone }) {
  const getYearLabel = (dateStr) => {
    const year = getYearInTimezone(dateStr, timezone);
    const currentYear = getYearInTimezone(new Date().toISOString(), timezone);
    const yearsAgo = currentYear - year;

    if (yearsAgo === 1) {
      return `${year} (1 year ago)`;
    }
    return `${year} (${yearsAgo} years ago)`;
  };

  return (
    <div className="bento-card bento-card--small">
      <div className="bento-card-header">
        <h2 className="bento-card-title">
          <span className="bento-card-icon">📅</span>
          On This Day
        </h2>
      </div>
      <div className="on-this-day-content">
        {(!memories || memories.length === 0) ? (
          <div className="on-this-day-empty">
            <p>No memories from this day yet.</p>
            <p>Keep recording to build your history!</p>
          </div>
        ) : (
          memories.slice(0, 3).map(memory => (
            <div
              key={memory.id}
              className="on-this-day-memory"
              onClick={() => onViewMemory(memory)}
            >
              <div className="on-this-day-year">
                {getYearLabel(memory.created_at)}
              </div>
              <div className="on-this-day-title">
                {memory.title || 'Untitled reflection'}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default OnThisDayCard;
